import React from 'react';
import Button from '@elements/button';
import { ShowMoreCommentProps } from './show-more-comment.props';
import ArrowDownIcon from '@icons-components/arrow-down-icon';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';

const ShowMoreComment = ({ showMore, showMoreHandler, lastPage, loading, currentPage }: ShowMoreCommentProps) => {
  const { lang } = useParams<{lang : 'fa'|'en'}>();
  const { modules: { comment } } = getDictionary(lang);
  const clickHandler = () => {
    if (!(lastPage === currentPage)) {
      showMoreHandler(currentPage + 1);
    }
  };

  if (showMore) {
    return (
      <Button
        className={'mt-7'}
        variant={'text'}
        loading={loading}
        startAdornment={<ArrowDownIcon/>}
        onClick={clickHandler}>
        {comment.buttons.show_more}
      </Button>
    );
  }

  return null;
};

export default ShowMoreComment;
